import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getStyles, translate } from '../../../../shared/utility';

import localStyles from './CharacterCounter.scss';
const styles = getStyles(localStyles);

const characterCounter = (props) => {
    const content = `${props.current} ${props.max > -1 ? '/ ' + props.max : ''} ${translate('ui.characters', props.language)}`;
    const invalid = (props.max > -1 && props.current > props.max) || (props.min > -1 && props.current < props.min);

    return (
        <span className={styles('align--right', 'tiny', (invalid ? 'c--error' : ''))}>
            {content}
        </span>
    );
};

characterCounter.propTypes = {
    // properties
    current: PropTypes.number.isRequired,
    min: PropTypes.number.isRequired,
    max: PropTypes.number.isRequired,

    language: PropTypes.string.isRequired
};

const mapStateToProps = state => {
    return {
        language: state.global.localization.language
    };
};

export default connect(mapStateToProps, null)(characterCounter);



// WEBPACK FOOTER //
// ./src/components/UI/Input/CharacterCounter/CharacterCounter.js